// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loadedItemsWrapper":"loadedItemsWrapper_MrqQH"};